import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { baseApi } from '@ibk/shared-config';
const getFeatureFlagHeaders = () => {
    const partyId = getSelectedAccountInfo()?.targetId;
    return partyId ? { 'x-tr-party-selected': partyId } : {};
};
export const operatorsApi = baseApi.injectEndpoints({
    endpoints: build => ({
        getOperators: build.query({
            query: ({ partyId }) => ({
                forceSelectedAccountInfoAccountId: true,
                url: '/v2/operators',
                headers: { 'party-id': partyId, ...getFeatureFlagHeaders() },
                timeout: 90000,
            }),
            transformResponse: (response) => {
                return response.result;
            },
            providesTags: ['Base'],
        }),
        deleteOperator: build.mutation({
            query: ({ fromParty, roleId, accountId }) => ({
                url: '/v2/operators',
                method: 'DELETE',
                body: { fromParty, roleId, ...(accountId && { accountId }) },
                headers: { ...getFeatureFlagHeaders() },
            }),
            invalidatesTags: ['Base'],
        }),
        getAccountInfo: build.query({
            query: ({ document }) => ({
                url: `/v1/party-service/person?documentNumber=${document}&documentType=1`,
            }),
            transformResponse: (response) => {
                return response.result;
            },
            providesTags: ['Base'],
        }),
        registerOperator: build.query({
            query: ({ payload }) => ({
                forceSelectedAccountInfoAccountId: true,
                url: '/v2/operators',
                method: 'POST',
                body: payload,
                headers: { ...getFeatureFlagHeaders() },
            }),
            transformResponse: (response) => {
                return response.result;
            },
            providesTags: ['Base'],
        }),
    }),
    overrideExisting: false,
});
export const { useGetOperatorsQuery, useDeleteOperatorMutation, useLazyGetAccountInfoQuery, useLazyRegisterOperatorQuery, } = operatorsApi;
